import {
  BTable,
  BFormInput,
  BFormGroup,
  BFormSelect,
  VBModal,
  BModal,
} from "bootstrap-vue";
import CreatePurchaseScore from "@@/core/components/customerClub/purchaseScore/CreatePurchaseScore.vue";

export default {
  name: "purchaseScoreSettings",
  components: {
    BTable,
    BFormInput,
    BFormGroup,
    BFormSelect,
    CreatePurchaseScore,
    BModal,
  },
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      disabled: false,
      url: "admin/customers_club/get_purchase_scores",
      editUrl: "admin/customers_club/set_purchase_score",
      type: "online",
      typeOptions: [
        { value: "online", text: "آنلاین" },
        { value: "physical", text: "حضوری" },
      ],
      items: [],
      fields: [
        {
          label: "شناسه",
          key: "id",
        },
        {
          label: "عنوان",
          key: "title",
        },
        {
          label: "حداقل مبلغ خرید",
          key: "min_value",
        },
        {
          label: "حداکثر مبلغ خرید",
          key: "max_value",
        },
        {
          label: "مقدار بن",
          key: "bon_value",
        },
        {
          label: "مقدار امتیاز",
          key: "score_value",
        },
        {
          label: "حذف",
          key: "delete",
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.disabled = true;
      await this.$axios
        .get(this.url, { params: { type: this.type } })
        .then((res) => {
          this.items = res.data.data.list;
          this.$root.notify(res.data.message, "success");
        })
        .catch((err) => {
          this.$root.notify(err);
        })
        .finally(() => {
          this.disabled = false;
        });
    },
    async submitChanges() {
      this.disabled = true;
      await this.$axios
        .put(this.editUrl, {
          type: this.type,
          customers_club_purchase_scores: [...this.items],
        })
        .then((res) => {
          this.$root.notify(res.data.message, "success");
        })
        .catch((err) => {
          this.$root.notify(err);
        })
        .finally(() => {
          this.disabled = false;
        });
    },
    deleteItem(id) {
      window
        .swal({
          title: "آیتم حذف شود؟",
          text: "این عملیات غیر قابل بازگشت خواهد بود",
          icon: "warning",

          showCancelButton: true,
          showConfirmButton: true,
          dangerMode: true,
          buttons: ["خیر", "بله حذف کن"],
        })
        .then((willDelete) => {
          if (willDelete) {
            this.$axios
              .delete(`admin/customers_club/delete_purchase_score?id=${id}`)
              .then((response) => {
                this.items = this.items.filter((item) => item.id != id);
                window.swal({
                  icon: "success",
                  showConfirmButton: true,
                  text: response.data.message,
                  button: "باشه",
                });
              })
              .catch((error) => {
                window.swal({
                  title: "خطا",
                  showConfirmButton: true,
                  text: error.response.data.message,
                  button: "باشه",
                });
              });
          }
        });
    },
    afterAddScore(list) {
      this.items = list;
    },
  },
};